import { makeCommonStore, FormField } from '../commons'
import ChecklistService from '@/services/ChecklistService.js'

const store = {
  ...makeCommonStore({
    service: ChecklistService,
    requiredFields: [],
    fields: [
      new FormField({
        name: 'type',
        type: 'select',
        label: 'Checklist type',
        items: [
          { text: 'Business', value: 'business' },
          { text: 'Personal', value: 'personal' }
        ]
      })
    ]
  }),
  namespaced: true
}

export default store
